"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "cacheCommand", {
    enumerable: true,
    get: function() {
        return command;
    }
});
const _commander = require("commander");
const _action = require("./action.js");
const _addOptions = require("../addOptions.js");
const command = new _commander.Command("cache");
(0, _addOptions.addOptions)("cache", command);
(0, _addOptions.addOptions)("logger", command);
command.action(_action.cacheAction);
